import { makeStyles } from '@material-ui/core';
import React, { useRef, useState, useEffect } from 'react';
import { object } from 'prop-types';
import { TeamMatchup } from './viewComponents/TeamMatchup'
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync'
import { OddsValuePair } from '../oddsList/OddsValue'
import ChevronRight from '../oddsList/images/chevron_right.png'
import { SportsBook } from '../odds/SportsBook'
import { OddsOpenerValue } from './viewComponents/OddsOpenerValue'
import LoadingOverlay from '../odds/LoadingOverlay';
import Overflow from 'react-overflow-indicator';
import { SportsBookLinks, getLineHistoryUrl } from '../../utils/gameUtils';
import ChevronLeft from '../oddsList/images/chevron_left.png'
import PropTypes from "prop-types";
import FullGame from './images/FullGame.png'
import { Link } from "react-router-dom";
export const styles = makeStyles(theme => ({
    table: {
        position: 'relative',
        overscrollBehavior: 'contain',
        fontSize: '12px',
        lineHeight: '150%',
        letterSpacing: '0.3px',
        color: '#232326',
        margin: 0,
        '& > div': {
            scrollbarWidth: 'none',
        },
    },
    header: {
        top: '136px',
        maxHeight: 54,
        zIndex: 4,
        borderTop: '1px solid #E5E5E5',
        borderBottom: '1px solid #E5E5E5',
        width: '100%',
        [theme.breakpoints.up('lg')]: {
            top: '160px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '156px'
        },
        '& > div': {
            scrollbarWidth: 'none',
        },
    },
    headerRow: {
        overflowX: 'hidden',
        display: 'inline-block',
    },
    rowContainer: {
        position: 'relative',
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '294px 108px',
        gridAutoFlow: 'column',
        gridAutoColumns: 106,
        '-webkit-overflow-scrolling': 'touch',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        [theme.breakpoints.down('1280')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 9)',
        },
        [theme.breakpoints.down('1180')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 8)',
        },
        [theme.breakpoints.down('1080')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 7)',
        },
        [theme.breakpoints.down('980')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 6)',
        },
        [theme.breakpoints.down('880')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 5)',
        },
        [theme.breakpoints.down('780')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 4)',
        },
        [theme.breakpoints.down('680')]: {
            gridAutoColumns: 'calc((100vw - 294px) / 3)',
        },
    },
    col: {
        borderBottom: '1px solid #E5E5E5',
        padding: '6px 0',
        "& p": {
            textAlign: 'center'
        },
        gridAutoColumns: 'min-content',
    },
    marketTitle: {
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1,
        fontWeight: '800',
        alignItems: 'flex-end !important',
        fontSize: 24,
        fontFamily: 'proxima-nova',
        color: '#000000',
        margin: '12px 0',
    },
    leftCol: {
        zIndex: -1,
        position: 'sticky',
        left: 0,
        backgroundColor: 'white',
    },
    dateRowCol: {
        zIndex: 4,
        position: 'sticky',
        left: 0,
        backgroundColor: 'white',
        borderRight: '1px solid #E5E5E5',
        fontSize: '14px',
        fontWeight: 700,
        "& p": {
            margin: '8px 0px',
            textAlign: 'left'
        }
    },
    heading: {
        height: 53,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end !important',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        fontWeight: 400,
        fontSize: 14,
        color: '#232326',
        '& img': {
            maxHeight: 22,
            width: 70,
            objectFit: 'contain',
            marginBottom: 4,
        },
        '& a': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
        },
    },
    gameDateHeader: {
        fontWeight: 400,
        justifyContent: 'space-between',
        zIndex: 5,
        borderTop: '1px solid #E5E5E5',
        backgroundColor: 'white',
        boxShadow: '4px 1px 5px -2px rgb(196 196 196 / 37%)',
        borderRight: '1px solid rgb(196 196 196 / 37%)',
        width: 294,
    },
    fullGame: {
        fontSize: 16,
        display: 'flex',
        flex: 1
    },
    items: {
        '-webkit-overflow-scrolling': 'touch',
        scrollbarWidth: 'none',
        overflowX: 'hidden',
    },
    teamMatchup: {
        display: 'flex',
        justifyContent: 'space-between',
        zIndex: 5,
        marginTop: 1,
        borderBottom: '1px solid #E5E5E5',
        padding: '8px 0',
        position: 'sticky',
        left: 0,
        backgroundColor: 'white',
        boxShadow: '4px 1px 5px -2px rgb(196 196 196 / 37%)',
        borderRight: '1px solid rgb(196 196 196 / 37%)',
    },
    openerValues: {
        width: '108 px',
        position: 'sticky',
        gridTemplateColumns: '0.5fr',
    },
    oddsValues: {
        borderBottom: '1px solid #E5E5E5',
        position: 'sticky',
        left: 220,
        backgroundColor: 'white'
    },
    allButton: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        maxWidth: '30px',
        maxHeight: '14px',
        '& img': {
            maxHeight: '100%',
            maxWidth: '100%',
        }
    },
    openerHeading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        fontSize: 14,
        paddingBottom: 4,
    },
    historyHeading: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: 2,
        width: 80,
    },
    stickyGameDateDiv: {
        position: 'sticky',
        zIndex: 5,
    },
    gameDateAbsoluteDiv: {
        position: 'absolute',
        left: '0',
        width: '295px',
        background: 'white',
        [theme.breakpoints.down('xs')]: {
            width: '160px'
        },
    },
    stickyDiv: {
        position: 'sticky',
        zIndex: 6,
    },
    chevronRight: {
        display: 'block',
        position: 'absolute',
        right: -16,
        top: 28,
        width: 16,
        objectFit: 'scale-down',
        "&:hover": {
            backgroundColor: `rgba(0,0,0,0.1)`
        },
        zIndex: 100,
        cursor: 'pointer',
    },
    chevronLeft: {
        display: 'block',
        position: 'absolute',
        left: 278,
        top: 28,
        width: 16,
        objectFit: 'scale-down',
        "&:hover": {
            backgroundColor: `rgba(0,0,0,0.1)`
        },
        cursor: 'pointer',
        zIndex: 100,
    },
}));

export default function OddsEventBrowserUI({ availableSportsBooks, league, game }) {
    const classes = styles();
    const leagueName = league.toLowerCase();
    const [newBooks, setNewBooks] = useState([]);
    let tempSportsBooks = [];
    let emptySportsBooks = [];
    availableSportsBooks.forEach(book => {
        const newBook = book === 'BetRivers' ? 'SugarHouseNJ' : book;
        for (let market in game.markets) {
            let books = Object.keys(game.markets[market]);
            if (books.includes(newBook)) {
                tempSportsBooks.push(book);
                break;
            }
        }
        if (!tempSportsBooks.includes(book)) {
            emptySportsBooks.push(book);
        }
    });
    useEffect(() => {
        setNewBooks(tempSportsBooks.concat(emptySportsBooks));
    }, [availableSportsBooks]);

    if (!game) {
        return <LoadingOverlay open={true} />
    }

    return (
        <>
            {
                (leagueName === 'nhl' || leagueName === 'mlb') &&
                <>
                    <div className={classes.marketTitle}>
                        MONEYLINES
                    </div>
                    <RenderGame
                        classes={classes}
                        availableSportsBooks={newBooks}
                        league={league}
                        marketFilter="2way"
                        game={game}
                    ></RenderGame>
                </>
            }
            <div className={classes.marketTitle}>
                {leagueName === 'nhl' && "PUCK LINES"}
                {leagueName === 'mlb' && 'RUN LINES'}
                {leagueName !== 'nhl' && leagueName !== 'mlb' && "SPREADS"}
            </div>
            <RenderGame
                classes={classes}
                availableSportsBooks={newBooks}
                league={league}
                marketFilter={leagueName === 'nhl' ? 'puck_line' : leagueName === 'mlb' ? 'run_line' : 'spread'}
                game={game}
            ></RenderGame>
            {
                leagueName !== 'nhl' && leagueName !== 'mlb' &&
                <>
                    <div className={classes.marketTitle}>
                        MONEYLINES
                    </div>
                    <RenderGame
                        classes={classes}
                        availableSportsBooks={newBooks}
                        league={league}
                        marketFilter="2way"
                        game={game}
                    ></RenderGame>
                </>
            }
            <div className={classes.marketTitle}>
                TOTALS
            </div>
            <RenderGame
                classes={classes}
                availableSportsBooks={newBooks}
                league={league}
                marketFilter="total"
                game={game}
            ></RenderGame>
        </>
    )
}

const RenderGame = ({ classes, marketFilter, game, availableSportsBooks, league }) => {
    const scrollPane = useRef();
    const leftHeading = useRef();

    const handleScroll = (direction) => {
        const rhsWidth = scrollPane.current.node.clientWidth - leftHeading.current.clientWidth;
        if (direction === 'right') {
            scrollPane.current.node.scrollLeft += rhsWidth;
        } else {
            scrollPane.current.node.scrollLeft -= rhsWidth;
        }
    };
    return (
        <Overflow>
            <div className={classes.stickyDiv}>
                <div className={classes.chevronDiv}>
                    <Overflow.Indicator direction="left">
                        <img alt="overflow left indicator" className={classes.chevronLeft} src={ChevronLeft} onClick={() => handleScroll('left')} />
                    </Overflow.Indicator>
                    <Overflow.Indicator direction="right">
                        <img alt="overflow right indicator" className={classes.chevronRight} src={ChevronRight} onClick={() => handleScroll('right')} />
                    </Overflow.Indicator>
                </div>
            </div>
            <div className={classes.stickyGameDateDiv}>
                <div className={classes.gameDateAbsoluteDiv}>
                    <div className={` ${classes.gameDateHeader} ${classes.heading}`} ref={leftHeading}>
                        <div className={classes.fullGame}>Full Game</div>
                        <div className={`${classes.historyHeading}`}>History</div>
                    </div>
                </div>
            </div>
            <ScrollSync>
                <div className={classes.table}>
                    <div className={classes.header}>
                        <ScrollSyncPane ref={scrollPane}>
                            <Overflow.Content>
                                <div className={`${classes.row} ${classes.headerRow}`} name="odds">
                                    <div className={`${classes.leftCol}`}>
                                    </div>
                                    <div className={`${classes.openerHeading}`}>Opener</div>
                                    {sportsBooks(classes, availableSportsBooks)}
                                </div>
                            </Overflow.Content>
                        </ScrollSyncPane>
                    </div>

                    <ScrollSyncPane>
                        <div className={classes.items}>
                            <div className={classes.rowContainer} key={game.id}>
                                <div className={`${classes.row} ${classes.oddsRow}`}>
                                    <div className={` ${classes.teamMatchup}`}>
                                        <div style={{ display: 'flex', flex: 1 }}>
                                            <TeamMatchup game={game} passedMarketFilter={marketFilter} />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 80 }}>
                                            <Link to={getLineHistoryUrl(league, game)} onClick={() => localStorage.setItem('marketFilter', marketFilter)}>
                                                <img src={FullGame} alt="line history icon" width={30} height={30} />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className={classes.col} style={{ display: 'flex' }}>
                                        <OddsOpenerValue game={game} marketFilter={marketFilter} />
                                    </div>
                                    {availableSportsBooks.map((book, id) => {
                                        return (
                                            <div className={`${classes.col}`} key={`${book}_${id}`}>
                                                <OddsValuePair game={game} marketFilter={marketFilter} sportsBook={book} />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </ScrollSyncPane>
                </div>
            </ScrollSync>
        </Overflow>
    )
}

const sportsBooks = (classes, availableSportsBooks) => availableSportsBooks.map(function (name) {
    return (
        <div key={name}>
            <div className={classes.heading}>
                <a href={SportsBookLinks[name]} target="_blank" rel="noreferrer">
                    <SportsBook name={name} />
                </a>
            </div>
        </div>
    );
});

OddsEventBrowserUI.propTypes = {
    classes: object,
    game: object,
    marketFilter: PropTypes.string
}